import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useDynamicRefs from 'use-dynamic-refs';
import { ChangeCountdownNumber, clearAction, mySession, pagesState, requestOTPAsync, resendOTPAsync, triggerDisableBtn, ValidateOTPAsync } from './controller';

export function OTP(props) {

    const dispatch = useDispatch();
    const pages_state = useSelector(pagesState);
    const my_Session = useSelector(mySession);
    const [getRef, setRef] = useDynamicRefs();

    var [loginMethod, setloginMethod] = useState(0);
    var handleLoginMethod = (index) => {
        setloginMethod(index);
        dispatch(clearAction());
    }

    useEffect(() => {
        if (!my_Session && (!sessionStorage.getItem('ue') || !sessionStorage.getItem('up'))) {
            props.history.push('/logi');
        }
    }, []);

    const validateOTP = (e) => {
        e.preventDefault();
        var data = {
            "key": pages_state ? pages_state.OTPKey : '',
            "otp": getRef('otp').current.value
        }

        dispatch(ValidateOTPAsync(data));
        //document.getElementById('loginForm').reset();
    }

    const resendOTP = (item) => {
        var countdown = 60;
        dispatch(triggerDisableBtn(true));
        // dispatch(ChangeCountdownNumber(countdown));
        var data = {
            "mode": item
        }
        dispatch(resendOTPAsync(data));

        var startResendOTP = setInterval(() => {
            countdown = countdown - 1;
            dispatch(ChangeCountdownNumber(countdown));
            if (countdown === 0) {
                clearInterval(startResendOTP);
                dispatch(triggerDisableBtn(false));
            }
        }, 1000);
    }

    const sendOtp = (item) => {
        var data = {
            "mode": item
        }
        dispatch(requestOTPAsync(data));
    }

    return (
        <section id="login">
            {(pages_state.status !== 'idle' || pages_state.status === 'rejected') && <div className="position-fixed loadingScreen d-flex justify-content-center align-items-center"><img src="./images/loading.gif" className="icons-loading" alt="" /></div>}
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">Enter OTP</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 mb-3">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body">
                                    <div>
                                        <p className="theme-color fw-bold faqTitle">Send OTP via:</p>
                                        <div>
                                            <label htmlFor="requestID">
                                                <input type="radio" name="loginas" id="requestID" className="me-2" checked={loginMethod === 0} onChange={() => handleLoginMethod(0)} />
                                                <span className="material-icons-outlined theme-color">email</span> OTP via Email
                                            </label>

                                        </div>
                                        <div className="mt-1">
                                            <label htmlFor="myLibraryID">
                                                <input type="radio" name="loginas" id="myLibraryID" className="me-2" checked={loginMethod === 1} onChange={() => handleLoginMethod(1)} />
                                                <span className="material-icons-outlined theme-color">smartphone</span> OTP via SMS
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        {loginMethod === 0 && <div>
                                            <form onSubmit={(e) => validateOTP(e)} id="loginForm">
                                                {pages_state && !pages_state.isRequestedOtp && <div className="text-center">
                                                    <div>
                                                        <p className="theme-color text-center">
                                                            Click "Send OTP" to receive the OTP via email.
                                                        </p>
                                                        <p className="theme-color text-center"><b>{sessionStorage.getItem('ue')}</b></p>
                                                        <div className="mt-4">
                                                            <button type="button" className="btn btn-primary" onClick={() => sendOtp('email')}>Send OTP</button>
                                                        </div>
                                                        
                                                    </div>
                                                </div>}
                                                {pages_state && pages_state.isRequestedOtp && <div className='text-center'>
                                                    <p className="theme-color m-0">
                                                        An OTP has been sent to <b>{sessionStorage.getItem('ue')}</b>.
                                                    </p>
                                                    <label htmlFor="username" className="col-form-label theme-color">Please enter OTP to proceed.</label>
                                                    <div>
                                                        <input type="number" onWheel={(e) => e.target.blur()} className="form-control w-100" id="username" ref={setRef('otp')} autoComplete="off" placeholder="6-digit OTP" required />
                                                    </div>
                                                    <div className="mt-1">
                                                            <button type="button" className="btn btn-link" disabled={pages_state ? pages_state.disableBtn : false} onClick={() => resendOTP('email')}>Resend OTP {pages_state && pages_state.disableBtn ? '(' + pages_state.countdownNo + ')' : ''}</button>
                                                        </div>
                                                    <div className="mt-3">
                                                        <button type="submit" className="btn btn-primary">Log in</button>
                                                    </div>

                                                </div>}
                                            </form>
                                        </div>}
                                        {loginMethod === 1 && <div>
                                            <form onSubmit={(e) => validateOTP(e)} id="loginForm">
                                                {pages_state && !pages_state.isRequestedOtp && <div className="text-center">
                                                    <div>
                                                        <p className="theme-color text-center">
                                                            Click "Send OTP" to receive the OTP via SMS.
                                                        </p>
                                                        <p className="theme-color text-center"><b>{sessionStorage.getItem('up')}</b></p>
                                                        <div className="mt-4">
                                                            <button type="button" className="btn btn-primary" onClick={() => sendOtp('mobile')}>Send OTP</button>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {pages_state && pages_state.isRequestedOtp && <div className='text-center'>
                                                    <p className="theme-color m-0">
                                                        An OTP has been sent to <b>{sessionStorage.getItem('up')}</b>.
                                                    </p>
                                                    <label htmlFor="username" className="col-form-label theme-color">Please enter OTP to proceed.</label>
                                                    <div>
                                                        <input type="number" onWheel={(e) => e.target.blur()} className="form-control w-100" id="username" ref={setRef('otp')} autoComplete="off" placeholder="6-digit OTP" required />
                                                    </div>
                                                    <div className="mt-1">
                                                            <button type="button" className="btn btn-link" disabled={pages_state ? pages_state.disableBtn : false} onClick={() => resendOTP('mobile')}>Resend OTP {pages_state && pages_state.disableBtn ? '(' + pages_state.countdownNo + ')' : ''}</button>
                                                        </div>
                                                    <div className="mt-3">
                                                        <button type="submit" className="btn btn-primary">Log in</button>
                                                    </div>
                                                </div>}
                                            </form>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





